<template>
    <section>
      <b-field>
        <b-select v-model="value" size="is-small">
          <!-- <option>Cabin Class</option> -->
          <option
              v-for="option in selectableCabins"
              :value="option.key"
              :key="option.key"
          >
              {{ option.label }} 
          </option>
        </b-select>
      </b-field>
    </section>
</template>

<script>
export default {
  props: {
    selectedValue : {
      type: String,
      default: 'Y'
    },
    cabinOptions: [],
  },  
  data() {
    return {
      allCabins: [
        {key: 'Y', label: 'Economy'},
        {key: 'M', label: 'Standard Economy'},
        {key: 'W', label: 'Premium Economy'},
        {key: 'C', label: 'Business'},
        {key: 'F', label: 'First'},
      ],
    }
  },
  computed: {
    selectableCabins() {
      let cabins = this.allCabins;

      if (this.cabinOptions) {
        cabins = cabins.filter((item) => {
          return this.cabinOptions.includes(item.key)
        })
      }

      return cabins;
    },
    value: {
      get() {
        return this.selectedValue;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
  },
}

</script>

<style scoped>
</style>
